const mexico = [
  { value: 'AGU', title: 'Aguascalientes' },
  { value: 'BCN', title: 'Baja California' },
  { value: 'BCS', title: 'Baja California Sur' },
  { value: 'CAM', title: 'Campeche' },
  { value: 'CMX', title: 'Ciudad de México' },
  { value: 'COA', title: 'Coahuila de Zaragoza' },
  { value: 'COL', title: 'Colima' },
  { value: 'CHP', title: 'Chiapas' },
  { value: 'CHH', title: 'Chihuahua' },
  { value: 'DUR', title: 'Durango' },
  { value: 'GUA', title: 'Guanajuato' },
  { value: 'GRO', title: 'Guerrero' },
  { value: 'HID', title: 'Hidalgo' },
  { value: 'JAL', title: 'Jalisco' },
  { value: 'MEX', title: 'México' },
  { value: 'MIC', title: 'Michoacán de Ocampo' },
  { value: 'MOR', title: 'Morelos' },
  { value: 'NAY', title: 'Nayarit' },
  { value: 'NLE', title: 'Nuevo León' },
  { value: 'OAX', title: 'Oaxaca' },
  { value: 'PUE', title: 'Puebla' },
  { value: 'QUE', title: 'Querétaro' },
  { value: 'ROO', title: 'Quintana Roo' },
  { value: 'SLP', title: 'San Luis Potosí' },
  { value: 'SIN', title: 'Sinaloa' },
  { value: 'SON', title: 'Sonora' },
  { value: 'TAB', title: 'Tabasco' },
  { value: 'TAM', title: 'Tamaulipas' },
  { value: 'TLA', title: 'Tlaxcala' },
  { value: 'VER', title: 'Veracruz de Ignacio de la Llave' },
  { value: 'YUC', title: 'Yucatán' },
  { value: 'ZAC', title: 'Zacatecas' },
];

export const usa = [
  { value: 'AL', title: 'Alabama' },
  { value: 'AK', title: 'Alaska' },
  { value: 'AZ', title: 'Arizona' },
  { value: 'AR', title: 'Arkansas' },
  { value: 'CA', title: 'California' },
  { value: 'CO', title: 'Colorado' },
  { value: 'CT', title: 'Connecticut' },
  { value: 'DE', title: 'Delaware' },
  { value: 'DC', title: 'District of Columbia' },
  { value: 'FL', title: 'Florida' },
  { value: 'GA', title: 'Georgia' },
  { value: 'HI', title: 'Hawaii' },
  { value: 'ID', title: 'Idaho' },
  { value: 'IL', title: 'Illinois' },
  { value: 'IN', title: 'Indiana' },
  { value: 'IA', title: 'Iowa' },
  { value: 'KS', title: 'Kansas' },
  { value: 'KY', title: 'Kentucky' },
  { value: 'LA', title: 'Louisiana' },
  { value: 'ME', title: 'Maine' },
  { value: 'MD', title: 'Maryland' },
  { value: 'MA', title: 'Massachusetts' },
  { value: 'MI', title: 'Michigan' },
  { value: 'MN', title: 'Minnesota' },
  { value: 'MS', title: 'Mississippi' },
  { value: 'MO', title: 'Missouri' },
  { value: 'MT', title: 'Montana' },
  { value: 'NE', title: 'Nebraska' },
  { value: 'NV', title: 'Nevada' },
  { value: 'NH', title: 'New Hampshire' },
  { value: 'NJ', title: 'New Jersey' },
  { value: 'NM', title: 'New Mexico' },
  { value: 'NY', title: 'New York' },
  { value: 'NC', title: 'North Carolina' },
  { value: 'ND', title: 'North Dakota' },
  { value: 'OH', title: 'Ohio' },
  { value: 'OK', title: 'Oklahoma' },
  { value: 'OR', title: 'Oregon' },
  { value: 'PA', title: 'Pennsylvania' },
  { value: 'RI', title: 'Rhode Island' },
  { value: 'SC', title: 'South Carolina' },
  { value: 'SD', title: 'South Dakota' },
  { value: 'TN', title: 'Tennessee' },
  { value: 'TX', title: 'Texas' },
  { value: 'UT', title: 'Utah' },
  { value: 'VT', title: 'Vermont' },
  { value: 'VA', title: 'Virginia' },
  { value: 'WA', title: 'Washington' },
  { value: 'WV', title: 'West Virginia' },
  { value: 'WI', title: 'Wisconsin' },
  { value: 'WY', title: 'Wyoming' },
];

const states = {
  mexico,
  usa,
};

export default states;
